const zh = {
	inputPlaceHolder: '请用中文或者英文输入',
	error: '出现错误，请稍后重试',
	login: {
		loginTitle: '登录PingPong Checkout',
		adminLogin: '管理员登录',
		operatorLogin: '操作员登录',
		email: '邮箱',
		loginPwd: '登录密码',
		forgetPwd: '忘记密码？',
		login: '登录',
		noAccount: '还没有账号？',
		register: '免费注册',
		emailTip: '请输入您的登录邮箱',
		pwdTip: '请输入您的登录密码',
		pwdLen: '密码至少为6位',
		formatterEmail: '请输入正确的邮箱格式',
		noRegister: '该账号没有开通PingPong Checkout，请先登记',
		incorrect: '您的账号或者密码错误， 请重新尝试',
		usernameError: '请输入您的账号',
		username: '登录名',
		operator: '操作员登录名',
		companyEmail: '公司注册邮箱',
		passwordLabel: '输入密码',
		accountBand: '账号未启用',
		authFailed: '身份验证失败',
		needRefreshGeeTest: '请再次进行人机验证',
		verifyCodeError:
      '您的账号因连续5次输入错误短信验证码已被暂时锁定，系统将于3小时后自动解除锁定。为保障账户安全，请勿重复获取或提交验证码。',
		passwordError:
      '您的账号因验证异常已被暂时锁定，系统将于3小时后自动解除锁定。为保障账户安全，请勿重复尝试登录。',
		errorTitle: '安全提示',
		poster: {
			title: '全球收单，品质之选',
			oneTitle: '极速开户，全球收单',
			oneDesc: '可受理70+国家或地区的260+种支付方式',
			twoTitle: '支持全球50+种主流币种支付',
			twoDesc: '美元、港币、日元、韩元、英镑、印尼盾等',
			threeTitle: '高可用性和稳定性',
			threeDesc:
        '完善的API体系，支持商户快速接入，稳定安全的交易处理流程，为您的生意保驾护航',
			fourTitle: '强大的产品平台',
			fourDesc:
        '完善的交易分析、订单管理、风险管理、店铺管理、用户管理等服务体系'
		}
	},
	register: {
		registerTitle: '注册PingPong Checkout',
		name: '联系人姓名',
		companyName: '公司名称',
		website: '公司网址',
		email: '注册邮箱',
		accountManger: '你的客户经理姓名（选填）',
		mobileNum: '手机号',
		verifyCode: '验证码',
		getValidate: '获取验证码',
		agreement: '我已阅读并同意PingPong',
		agreementMerchant: '特约商户服务条款',
		registerNow: '注册',
		nowLogin: '立即登录',
		nameInput: '请输入您的姓名',
		incorrectEmail: '邮箱不符合规则',
		incorrectPhone: '手机号不符合规则',
		readAgreement: '请确认阅读并同意特约商户服务条款',
		readAgreementV2: '请确认阅读并同意《用户协议》和《隐私政策》',
		sendValidate: '验证码发送成功',
		errorValidate: '验证码错误',
		resend: '再次发送',
		existMobile: '该手机号已被注册，请修改。',
		existPhone: '手机号已注册',
		existEmail: '邮箱已注册',
		registerSuccess: '登记成功',
		notice: '您已经注册成功, \n 请注意查收邮件以激活账户',
		ok: '好的',
		expireValidate: '验证码已失效，请重新获取',
		emptyEmail: '请输入您的邮箱',
		emptyPhone: '请输入您的手机号码',
		selectManager: '请选择客户经理',
		type: '类型',
		selectClientType: '请选择注册类型',
		emptyClientType: '请选择注册类型',
		switchText: '已有账号，',
		nextStep: '下一步',
		emptyCompanyName: '请输入您的公司名称',
		emptyWebsite: '请输入您的公司网址',
		emptyRegisterAddress: '请选择您的公司注册地所在地',
		registerAddress: '公司注册地所在地',
		openAccountDialog: {
			title: '开通收单业务',
			content:
        '您已注册PingPong旗下其他业务，现可一键开通收单业务，使用相同账号密码登录。',
			confirm: '一键开通',
			cancel: '取消'
		},
		accountExistsDialog: {
			title: '邮箱已被占用',
			content:
        '该邮箱已注册并完成其他地区认证，无法用于当前地区业务。请使用其他邮箱地址重新注册。',
			confirm: '更换邮箱',
			cancel: '取消'
		}
	},
	forgetPwd: {
		forgetTitle: '忘记密码',
		forgetSubTitle: '填写下列信息以便确认您的身份',
		phone: '电话号码',
		email: '邮箱',
		validateCode: '验证码',
		getValidateCode: '获取验证码',
		confirm: '确认',
		backLogin: '返回登录',
		incorrectPhone: '手机号不符合规则',
		notUsedPhone: '该号码并未开通PingPong Checkout',
		notUsedEmail: '该邮箱并未开通 PingPong Checkout',
		resend: '再次发送',
		phoneInput: '请输入您的手机号码',
		incorrectValidate: '验证码错误',
		emptyValidate: '请输入验证码',
		emptyEmail: '请输入您的邮箱',
		incorrectEmail: '邮箱不符合规则',
		newPwdSubTitle: '输入您的新密码',
		newPwd: '新密码',
		confirmNewPwd: '重新输入新密码',
		incorrectPwd: '密码不符合规则',
		pwdRules: '英文开头 包含数字、大小写字母任意两种 6-20字符',
		strong: '强',
		normal: '中',
		weak: '弱',
		secondInput: '密码不匹配。',
		successSubmit: '提交成功',
		successModify: '修改成功',
		newPwdtips:
      '现在您可以使用您的新密码登录PingPong Checkout。注意：短时间内多次修改密码的账户会被锁定，请记牢您的密码。',
		emailLabel: '输入邮箱',
		verifyCodeLabel: '邮箱验证码',
		verifyCodeTip: '请输入邮件中显示的验证码',
		pwdLabel: '输入密码',
		checkPwdLabel: '确认密码',
		verifyCodePhoneLabel: '手机验证码(短信将发送至{phoneNo})',
		sendValidate: '验证码发送成功',
		expireValidate: '验证码已失效，请重新获取',
		errorValidate: '验证码错误'
	},
	setNewPwd: {
		newPwd: '设置您的登录密码',
		fstPwd: '初次使用我们会要求你修改默认密码',
		comfirmPwd: '确认密码',
		nextLogin: '下次登录时，请使用新的密码。',
		mainLand: '中国大陆',
		home: '首页',
		product: '产品',
		faq: '常见问题'
	},
	account: {
		title: '填写账户信息',
		emailTip: '邮箱地址将作为您的账户登录名',
		code: '邮箱验证码',
		codeTip: '请输入邮件中显示的验证码',
		createAndLogin: '创建账号并登录',
		userProtocol: '《用户协议》',
		privacyProtocol: '《隐私政策》',
		service: '《收单服务特别规则》',
		usaSpecialTerms: '《美国特殊条款》'
	},
	verifyCode: {
		title: '短信验证码',
		content: '已向您{phoneNumber}的手机号码发送了一个6位数字验证码，请查收。',
		subTitle: `没有收到验证码？重新发送`,
		errorCode: '验证码错误',
		getValidate: '获取验证码',
		resend: '再次发送',
		cancel: '取消',
		continue: '继续',
		emptyValidate: '请输入验证码',
		expireValidate: '验证码已失效，请重新获取',
		reviewText: '当前账号异常，请稍后再试'
	},
	passwordValidator: {
		title: '您的密码应该'
	}
}

export default zh
